import { FormLabel, Grid, MenuItem, Select } from "@mui/material"
import { useCallback, useMemo, useState } from "react"
import api from "../../utils/api";
import { StringNumber, TSede } from "../../types";

export const SelectSedeGrupo = ({
  value: _val,
  action
}: {
  value: StringNumber,
  action: any
}) => {

  const [sedes, setSedes] = useState<{descricao: string, id: number}[]>();
  const [sede, setSede] = useState<{descricao: string, id: number}>();

  const getGrupoSede = async () => {
    try {
      const req = await api.get('sede/grupo');
      const res = req?.data;

      setSedes(res);
    } catch (error) {

    }
  }

  const selectSede = (value: StringNumber) => {
    let sedeSelected = sedes?.find((sed) => sed?.id == value);
    setSede(sedeSelected);
    action(sedeSelected?.id);
  }

  useMemo(() => {
    getGrupoSede()
  }, [])


  const Selecter = useCallback(
    () => {
      return (
        <Select
          defaultValue={_val}
          value={sede?.id}
          onChange={(event) => selectSede(event?.target?.value)}
        >
          {
            sedes?.map(sede =>
              <MenuItem value={sede?.id}>
                {sede?.descricao}
              </MenuItem>
            )
          }
        </Select>
      )
    },
    [_val, sedes])

  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>Grupo Sede</FormLabel>
        <Selecter/>
      </Grid>
    </>
  )
}
